<template>
  <a :href="href" class="listen-cta">
    <img class="listen-cta__audio-player-icon" :src="playIcon" :alt="$t('copy')" />

    <div class="listen-cta__audio-player-copy">
      {{ $t("copy") }}
    </div>
  </a>
</template>

<script>
import playIcon from "../images/play.svg"

export default {
  name: "ListenCta",
  props: {
    href: { type: String, default: null }
  },
  data() {
    return {
      playIcon: playIcon
    }
  },
  i18n: {
    messages: {
      en: {
        copy: "Listen to the first key idea"
      },
      de: {
        copy: "Erste Kernaussage öffnen"
      },
      es: {
        copy: "Escucha la primera idea clave"
      }
    }
  }
}
</script>

<style lang="scss">
.listen-cta {
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 10px 0;

  background-color: $midnight;

  border-radius: $spacing-4;

  &__audio-player-icon {
    margin-right: $spacing-8;

    color: $white;
  }

  &__audio-player-copy {
    @include font-style(subheadline, $color: $white);
  }
}
</style>
